import React, {Component} from 'react'
import {Form, Header, Icon, Select} from 'semantic-ui-react'

const options = [
    {key: 'ios', text: 'iOS', value: 'ios', icon: 'apple'},
    {key: 'android', text: 'Android', value: 'android', icon: 'android'},
]

class DeviceInformation extends Component {

    constructor(props) {
        super(props)
        this.state = {
            selectedDevice: props.data.phone_type || "",
        }
    }

    handleDeviceChange = (e, {value}) => {
        this.setState({selectedDevice: value})
        this.props.change('phone_type', value)

    }

    render() {
        return (
            <div>
                <Header as='h3' dividing>
                    <Icon name='mobile'/>
                    <Header.Content>
                        Device Information
                        <Header.Subheader>
                            Select your mobile device
                        </Header.Subheader>
                    </Header.Content>
                </Header>
                <Form.Field control={Select} value={this.state.selectedDevice}
                            onChange={this.handleDeviceChange.bind(this)}
                            label='Device' options={options} placeholder='Device'/>
            </div>
        )
    }
}

export default DeviceInformation


// WEBPACK FOOTER //
// ./src/containers/register/DeviceInformation.js